import React from 'react';
import Update from './Children/Update';
import PasswordRecovery from './Children/PasswordRecovery';
import Profile from './Children/Profile';

export const ProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'profileGroup',
      path: 'myself',
      children: [
        {
          id: 'profile.myself',
          path: '',
          element: <Profile />,
        },
        {
          id: 'profile.myself.update',
          path: 'update/:id?',
          element: <Update />,
        },
        {
          id: 'profile.myself.passwordRecovery',
          path: 'recovery/:id?',
          element: <PasswordRecovery />,
        },
      ],
    },
  ],
};
